import { PageFallback } from "components/PageFallback";
import { lazy, Suspense } from "react";

let ContactUs = lazy(() => import("./ContactUs"));

export async function lazyContactUsLoader() {
    const componentModule = await import("./ContactUs");
    // This avoid flicker from React.lazy by using the component directly
    ContactUs = componentModule.default as any;

    return null;
}

export function LazyContactUs() {
    return (
        <Suspense fallback={<PageFallback />}>
            <ContactUs />
        </Suspense>
    );
}
